var React = require('react');

function LandingPageHeroBlobRightInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M7.4 560H64V0H1.9c.4 82.9 27 174.9 26.4 275.5 0 95.1-24.1 197.2-20.9 284.5z","fill":"currentColor"}));
}

LandingPageHeroBlobRightInline.defaultProps = {"width":"64","height":"560","viewBox":"0 0 64 560"};

module.exports = LandingPageHeroBlobRightInline;

LandingPageHeroBlobRightInline.default = LandingPageHeroBlobRightInline;
